import { useGetMultiDataSources } from '../queries';
import { IntegrationType, ListDataSourcesResponse } from '../types';

export const useIsPmsSyncEligible = ({ locationIds }: { locationIds: string[] }) => {
  const results = useGetMultiDataSources<boolean>({ locationIds }, { select: (data) => checkPmsSyncEligibility(data) });

  return {
    isEligible: results.some((result) => Boolean(result.data)),
    isLoading: results.some((result) => result.isLoading),
  };
};

// Add more integration types as needed
const PMS_SYNC_ELIGIBLE_INTEGRATION_TYPES = [IntegrationType.ON_PREM, IntegrationType.CLOUD];

const checkPmsSyncEligibility = (dataSourcesResponse: ListDataSourcesResponse) => {
  return Boolean(
    dataSourcesResponse.dataSources?.some((dataSource) => {
      return (
        !!dataSource.integration?.type && PMS_SYNC_ELIGIBLE_INTEGRATION_TYPES.includes(dataSource.integration?.type)
      );
    })
  );
};
